// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Js_dict = require("rescript/lib/js/js_dict.js");

function storageKeyToString(storageKey) {
  if (typeof storageKey === "number") {
    if (storageKey !== 0) {
      return "validationKey";
    } else {
      return "indexes";
    }
  } else {
    return storageKey._0;
  }
}

var keyPrefix = "sv$";

function readFromStorage(storageKey) {
  var keyWithPrefix = keyPrefix + storageKeyToString(storageKey);
  return browser.storage.local.get(keyWithPrefix).then(function (storageResult) {
              return Promise.resolve(Js_dict.get(storageResult, keyWithPrefix));
            });
}

function deleteFromStorage(storageKey) {
  var keyWithPrefix = keyPrefix + storageKeyToString(storageKey);
  return browser.storage.local.remove(keyWithPrefix).then(function (param) {
              return Promise.resolve(true);
            });
}

exports.storageKeyToString = storageKeyToString;
exports.keyPrefix = keyPrefix;
exports.readFromStorage = readFromStorage;
exports.deleteFromStorage = deleteFromStorage;
/* No side effect */
